import { initializeGTM } from './google_tag_manager';
import { initSentry } from './sentry';
import { scheduleBootstrap } from './utils/session_bootstrap';
import '@hotwired/turbo-rails';
import './controllers/pflegegrad_rechner_controllers';

// Initialize Sentry
initSentry();

// Fire the page-view beacon (reads data-page-view from the edge-cached body)
scheduleBootstrap();

window.addEventListener('load', () => {
    initializeGTM();
});

document.addEventListener("turbo:load", function() {
    // The page gets filled with the new question and previous questions when a question
    // is answered. So we first insta scroll to the question we just answered and then
    // scroll to the new one smoothly 
    var prev = document.getElementById("prev-question")
    var element = document.getElementById("current-question");
    if (prev) {
        prev.scrollIntoView({behavior: "instant", block: "start"});
    }
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: "start" });
    }
});